
import React, { useState, useRef, useEffect } from "react";
import { API_URLS } from "../../apiUrl";
import * as CryptoJS from "crypto-js";
import axiosInstance from "../../components/axiosInstance";

type FormData = {
  municipality_name: string;
  login_user_name: string;
  password: string;
  admin_name: string;
  logo: File | null;
  banner_image: File | null;
  municipalty_chairman_person_name: string;
  municipalty_offical_address: string;
  gst: string;
  tan: string;
  pan: string;
  state_id: number;
  city_id: number;
  role_id: number;
  email: string;
};

const AddMunicipality: React.FC = () => {
  const [formData, setFormData] = useState<FormData>({
    municipality_name: "",
    login_user_name: "",
    password: "",
    admin_name: "",
    logo: null,
    banner_image: null,
    municipalty_chairman_person_name: "",
    municipalty_offical_address: "",
    gst: "",
    tan: "",
    pan: "",
    state_id: 0,
    city_id: 0,
    role_id: 2,
    email: "",
  });

  const [errors, setErrors] = useState<any>({});
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [failedMessage, setfailedMessage] = useState<string>("");
  const [dataExistMessage, setDataExistMessage] = useState<string>("");
  const formRef = useRef<HTMLFormElement>(null);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLSelectElement> | any
  ) => {
    const { name, value, type, files } = e.target;

    if (type === "file") {
      setFormData({
        ...formData,
        [name]: files ? files[0] : null,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  const validateForm = (): boolean => {
    const newErrors: any = {};
    if (!formData.municipality_name) {
      newErrors.municipality_name = "Municipality Name is required";
    } else {
      const adminNameRegex = /^[A-Za-z\s]+$/;

      if (!adminNameRegex.test(formData.municipality_name)) {
        newErrors.municipality_name = "Municipality Name should only contain alphabets and spaces.";
      }
    }

    if (!formData.login_user_name) {
      newErrors.login_user_name = "Login User Name is required";
    } else if (!/^[A-Za-z0-9@.]+$/.test(formData.login_user_name)) {
      newErrors.login_user_name = "Login User Name must be alphanumeric or contain @ and . only";
    }
    
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else {
      const passwordPattern = /^(?=.*\d)(?=.*[!@#$%^&*(),.?":{}|<>])[A-Za-z\d!@#$%^&*(),.?":{}|<>]{5,}$/;
      if (!passwordPattern.test(formData.password)) {
        newErrors.password = "Password must be at least 5 characters long, contain at least one special character, and one number.";
      }
    }
    
    if (!formData.admin_name) {
      newErrors.admin_name = "Admin Name is required";
    } else {
      const adminNameRegex = /^[A-Za-z\s]+$/;

      if (!adminNameRegex.test(formData.admin_name)) {
        newErrors.admin_name = "Admin Name should only contain alphabets and spaces.";
      }
    }

    if (formData.municipalty_chairman_person_name) {
      const adminNameRegex = /^[A-Za-z\s]+$/;
  
      if (!adminNameRegex.test(formData.municipalty_chairman_person_name)) {
          newErrors.municipalty_chairman_person_name = "Chairman Name should only contain alphabets and spaces.";
      }
  }
  
    if (!formData.gst) {
      newErrors.gst = "GST is required";
    } else {
      const gstRegex = /^[A-Z0-9]{15}$/
      if (!gstRegex.test(formData.gst)) {
        newErrors.gst = "Invalid GST format. Please provide a valid GST number (Characters Should be in Caps).";
      }
    }

    if(formData.tan.trim()) {
      const tanRegex = /^[A-Z]{4}[0-9]{5}[A-Z]{1}$/;

      if (!tanRegex.test(formData.tan)) {
        newErrors.tan = "Invalid TAN format. Please provide a valid TAN number (Characters Should be in Caps).";
      }
    }
    if(formData.pan.trim()) {
      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

      if (!panRegex.test(formData.pan)) {
        newErrors.pan = "Invalid PAN format. It should be in the format ABCD1234E (Characters Should be in Caps).";
      }
    }
    if (!formData.state_id) newErrors.state_id = "State ID is required";
    if (!formData.city_id) newErrors.city_id = "City ID is required";
    if (!formData.role_id) newErrors.role_id = "Role ID is required";
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@gmail\.com$/;
      if (!emailPattern.test(formData.email)) {
        newErrors.email = "Email must be in the format name@gmail.com";
      }
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetForm = () => {
    setFormData({
      municipality_name: "",
      login_user_name: "",
      password: "",
      admin_name: "",
      logo: null,
      banner_image: null,
      municipalty_chairman_person_name: "",
      municipalty_offical_address: "",
      gst: "",
      tan: "",
      pan: "",
      state_id: 0,
      city_id: 0,
      role_id: 0,
      email: "",
    });
    setErrors({
      municipality_name: "",
      login_user_name: "",
      password: "",
      admin_name: "",
      logo: null,
      banner_image: null,
      municipalty_chairman_person_name: "",
      municipalty_offical_address: "",
      gst: "",
      tan: "",
      pan: "",
      state_id: 0,
      city_id: 0,
      role_id: 0,
      email: "",
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const hashedPassword = CryptoJS.MD5(formData.password).toString();
    const updatedFormData: any = { ...formData, password: hashedPassword };
    if (validateForm()) {
      const formDataToSend = new FormData();

      for (const key in updatedFormData) {
        if (updatedFormData[key]) {
          formDataToSend.append(key, updatedFormData[key]);
        }
      }
      try {
        const response = await axiosInstance.post(`${API_URLS.InsertMunicipality}`, formDataToSend);


        if (response.data.data.message == "GST number already exists" || response.data.data.message == "TAN number already exists" || response.data.data.message == "PAN number already exists") {
    
          setDataExistMessage(`${response.data.data.message}`);
          setTimeout(() => {
            setDataExistMessage("");
          }, 5000);
        } else {
          resetForm();
          setSuccessMessage(`${response.data.message}`);
          setTimeout(() => {
            setSuccessMessage("");
          }, 5000);
        }


        setErrors({});
      } catch (error) {
        setfailedMessage("Municipality Add failed.");
        setTimeout(() => {
          setfailedMessage("");
        }, 5000);
      }
      finally {

      }
    }
  };

  const handleClickOutside = (e: MouseEvent) => {
    if (formRef.current && !formRef.current.contains(e.target as Node)) {
      setErrors({});
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="max-w-full mx-auto">
      <div className='flex flex-col gap-5'>
        <h1 className="text-2xl font-semibold text-gray-800 dark:text-gray-100">Add Municipality</h1>
        <div className="p-6 bg-white rounded-lg shadow-lg dark:bg-gray-800">
          <form ref={formRef} onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
              {/* Municipality Name */}
              <div>
                <label htmlFor="municipality_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Municipality Name <span className="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  id="municipality_name"
                  name="municipality_name"
                  value={formData.municipality_name}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
                {errors.municipality_name && (
                  <p className="text-sm text-red-600 mt-1">{errors.municipality_name}</p>
                )}
              </div>

              {/* Login User Name */}
              <div>
                <label htmlFor="login_user_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Login User Name <span className="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  id="login_user_name"
                  name="login_user_name"
                  value={formData.login_user_name}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
                {errors.login_user_name && (
                  <p className="text-sm text-red-600 mt-1">{errors.login_user_name}</p>
                )}
              </div>

              {/* Password */}
              <div>
                <label htmlFor="password" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Password <span className="text-red-600">*</span>
                </label>
                <input
                  type="password"
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder='E.g. Test@1234'
                />
                {errors.password && (
                  <p className="text-sm text-red-600 mt-1">{errors.password}</p>
                )}
              </div>

              <div>
                <label htmlFor="admin_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Admin Name <span className="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  id="admin_name"
                  name="admin_name"
                  value={formData.admin_name}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
                {errors.admin_name && (
                  <p className="text-sm text-red-600 mt-1">{errors.admin_name}</p>
                )}
              </div>

              <div>
                <label htmlFor="municipalty_chairman_person_name" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Municipality Chairman Name
                </label>
                <input
                  type="text"
                  id="municipalty_chairman_person_name"
                  name="municipalty_chairman_person_name"
                  value={formData.municipalty_chairman_person_name}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
                {errors.municipalty_chairman_person_name && (
                  <p className="text-sm text-red-600 mt-1">{errors.municipalty_chairman_person_name}</p>
                )}
              </div>

              <div>
                <label htmlFor="municipalty_offical_address" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Municipality Official Address
                </label>
                <input
                  type="text"
                  id="municipalty_offical_address"
                  name="municipalty_offical_address"
                  value={formData.municipalty_offical_address}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
              </div>

              <div>
                <label htmlFor="gst" className=" flex gap-2 mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  GST <span className="text-red-600">*</span> <span className="text-red-500 block text-xs font-medium leading-1">(E.g. 29GGGGG1314R9Z6)</span>
                </label>
                <input
                  type="text"
                  id="gst"
                  name="gst"
                  value={formData.gst}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
                {errors.gst && (
                  <p className="text-sm text-red-600 mt-1">{errors.gst}</p>
                )}
              </div>

              {/* TAN */}
              <div>
                <label htmlFor="tan" className="flex gap-2 mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  TAN 
                  {/* <span className="text-red-600">*</span>  */}
                  <span className="text-red-500 block text-xs font-medium leading-1">(E.g. ABCD12345K)</span>
                </label>
                <input
                  type="text"
                  id="tan"
                  name="tan"
                  value={formData.tan}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
                {errors.tan && (
                  <p className="text-sm text-red-600 mt-1">{errors.tan}</p>
                )}
              </div>

              <div>
                <label htmlFor="pan" className="flex gap-2 mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  PAN 
                  <span className="text-red-500 block text-xs font-medium leading-1">(E.g. ABCDE6789K)</span>
                </label>
                <input
                  type="text"
                  id="pan"
                  name="pan"
                  value={formData.pan}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
                {errors.pan && (
                  <p className="text-sm text-red-600 mt-1">{errors.pan}</p>
                )}
              </div>

              <div>
                <label htmlFor="state_id" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  State <span className="text-red-600">*</span>
                </label>
                <select
                  id="state_id"
                  name="state_id"
                  value={formData.state_id}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                >
                  <option value="0">Select State</option>
                  <option value="1">West Bengal</option>
                </select>
                {errors.state_id && (
                  <p className="text-sm text-red-600 mt-1">{errors.state_id}</p>
                )}
              </div>

              <div>
                <label htmlFor="city_id" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  City <span className="text-red-600">*</span>
                </label>
                <select
                  id="city_id"
                  name="city_id"
                  value={formData.city_id}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                >
                  <option value="0">Select City</option>
                  <option value="1">Kolkata</option>
                  <option value="2">Tamluk</option>
                </select>
                {errors.city_id && (
                  <p className="text-sm text-red-600 mt-1">{errors.city_id}</p>
                )}
              </div>

              <div>
                <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
                  Email <span className="text-red-600">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:outline-0 focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                />
                {errors.email && (
                  <p className="text-sm text-red-600 mt-1">{errors.email}</p>
                )}
              </div>

              <div className="sm:col-span-3 flex justify-center">
                <button
                  type="submit"
                  className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm w-full sm:w-auto px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                >
                  Add Municipality
                </button>
              </div>
            </div>
          </form>

          {successMessage && (
            <div className="mt-4 p-4 bg-green-600 text-white rounded-lg flex justify-between items-center">
              <span>{successMessage}</span>
              <button
                onClick={() => setSuccessMessage('')}
                className="ml-4 text-white font-bold text-lg focus:outline-none"
              >
                &times;
              </button>
            </div>
          )}


          {failedMessage && (
            <div className="mt-4 p-4 bg-red-600 text-white rounded-lg flex justify-between items-center">
              <span>{failedMessage}</span>
              <button
                onClick={() => setfailedMessage('')}
                className="ml-4 text-white font-bold text-lg focus:outline-none"
              >
                &times;
              </button>
            </div>
          )}

          {dataExistMessage && (
            <div className="mt-4 p-4 bg-yellow-600 text-white rounded-lg flex justify-between items-center">
              <span>{dataExistMessage}</span>
              <button
                onClick={() => setDataExistMessage('')}
                className="ml-4 text-white font-bold text-lg focus:outline-none"
              >
                &times;
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddMunicipality;
